import(/* webpackMode: "eager", webpackExports: ["AdminAuthProvider"] */ "/work/apps/frontend/src/shared/auth/admin-provider.tsx");
